// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"433":"8c24b2c5","436":"1f971280"}[chunkId] + ".chunk.css";
};